import { ObjectSchema } from './types';

/**
 * Merge multiple object schemas shallowly
 *
 * Note: This function assumes that all schemas have
 * _distinct_ properties. If two or more schemas have the
 * same property name, only the last one will be used.
 *
 * This function is only used to merge root-level object schemas
 * in our array-based form wizard structure, so any additional properties
 * such as $uiOptions will be discarded.
 */
export default function mergeObjectSchemas(
  schemas: Array<ObjectSchema>
): ObjectSchema {
  const result: ObjectSchema = {
    type: 'object',
    properties: {}
  };

  const required = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const schema of schemas) {
    Object.assign(result.properties || {}, schema.properties);

    if (schema.required) {
      required.push(...schema.required);
    }
  }

  if (required.length > 0) {
    result.required = [...new Set(required)];
  }

  return result;
}
